import { render, staticRenderFns } from "./AccidentsReport.vue?vue&type=template&id=cdacbabc&scoped=true"
import script from "./AccidentsReport.vue?vue&type=script&lang=js"
export * from "./AccidentsReport.vue?vue&type=script&lang=js"
import style0 from "./AccidentsReport.vue?vue&type=style&index=0&id=cdacbabc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdacbabc",
  null
  
)

export default component.exports